var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10523_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 28H27.2251C28.5903 28 29.5542 29.3374 29.1225 30.6325L25.9117 40.2649C25.3672 41.8983 23.8387 43 22.117 43H11.7239C9.84216 43 8.21489 41.6885 7.81516 39.8497L6 31.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 47,
    r: 2,
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 47,
    r: 2,
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18H46.5",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 8H46.5",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 28L47 28",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12H6V18H3V12Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18V15H19V18",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15V12.5H21V18",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 10.5H33V12.7929L33.5 13.2929L34 12.7929V11H36V12.7929L37 13.7929V18H36V14.2071L35 13.2071L34 14.2071V18V18.5H31H30H27V13.7929L28 12.7929V11H30V12.7929L30.5 13.2929L31 12.7929V10.5ZM33 17.5V14.2071L32 13.2071L31 14.2071V17.5H33ZM30 14.2071V17.5H28V14.2071L29 13.2071L30 14.2071Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 20.5H41V22.7929L41.75 23.5429L42 23.2929V21.5H44V23.2929L45 24.2929V28.5H44V24.7071L43 23.7071L42 24.7071V28.5H41H39H38H35V23.7929L36 22.7929V21H38V22.7929L38.5 23.2929L39 22.7929V20.5ZM41 27.5V24.2929V24.2071L40 23.2071L39 24.2071V27.5H41ZM38 24.2071V27.5H36V24.2071L37 23.2071L38 24.2071Z",
    fill: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10523_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 49,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperMarket);
export default __webpack_public_path__ + "static/media/HyperMarket.189ca080b8c2dba7d6d542b01ead484e.svg";
export { ForwardRef as ReactComponent };